<template>
  <div>
    <bl-service :from="from" />
    <!-- <div class="callService shadow van-hairline&#45;&#45;surround bg-white">
      <van-row
        type="flex"
        align="center"
        class="text-center gray"
        @click="$router.push({ path: '/service' })"
      >
        <van-col span="4" class="box"> &nbsp; </van-col>
        <van-col span="16" class="box"> &nbsp; </van-col>
        <van-col span="4" class="box"> &nbsp; </van-col>
      </van-row>
    </div> -->
  </div>
</template>

<script>
import { Cell, Image as VanImage } from "vant";
import blService from "Components/blService/index";

export default {
  name: "LdAddress",
  components: {
    [Cell.name]: Cell,
    [VanImage.name]: VanImage,
    [blService.name]: blService,
  },
  props: {
    title: {
      type: [String],
      default: "",
    },
    from: {
      type: String,
    },
  },
  data() {
    return {
      show: false,
      addShow: false,
      addressList: [],
    };
  },
  created() {},
  methods: {
    select(address) {
      this.show = false;
      this.$emit("selected", address);
    },
    toggle() {
      this.show = !this.show;
    },
  },
};
</script>

<style lang="less" scoped>
.callService {
  position: fixed;
  bottom: 60px;
  left: 0;
  right: 0;
  background-image: url("~Assets/images/tk/tkList/callMe.png");
  background-repeat: no-repeat;
  background-size: 100%;
}
.box {
  padding: 10px;
}
</style>
